import { useEffect } from 'react';
import { isBrand } from '../../Helpers/user_helpers';
import { EventNames } from '../../Helpers/event_constants';
import { addEvent } from '../../APIClient/events';

const ShopGuide = props => {
  useEffect(() => {
    const isBrandUser = isBrand(props.user);
    if (isBrandUser) {
      addEvent(EventNames.BRAND_GUIDE_PAGE_VIEW)
    }
    window.location.href = isBrandUser ? 'https://brands.shopmy.us' : 'https://guide.shopmy.us';
  }, [props.user]);
  return null;
};

export default ShopGuide;
